export enum MarketplaceListingAssetType {
  IMAGE = 'image',
  HERO_IMAGE = 'hero_image',
}
